import React from "react";
import "./tooltip.sass";
const Tooltip = ({ text, component, style }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "tint-tooltip-container" }, component, /* @__PURE__ */ React.createElement("div", { style, className: "tint-tooltip-container__tint-tooltip" }, /* @__PURE__ */ React.createElement("span", null, text)));
};
export default Tooltip;
